(() => {
  function init() {
    const root = document.getElementById('montage-instructions');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('.mi-card')];
    const details = [...root.querySelectorAll('.mi-detail')];
    const search = root.querySelector('input[type=search]');
    const count = root.querySelector('.mi-count');
    const models = root.querySelector('.mi-models');
    const overview = root.querySelector('.mi-overview-head');
    const filters = [...root.querySelectorAll('.mi-filters button')];
    let brand = '', active = null, origin = null;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    root.querySelector('.mi-controls').hidden = false;
    root.querySelector('.mi-filters').hidden = false;

    function stop() {
      details.forEach(detail => {
        detail.hidden = true;
        const media = detail.querySelector('.mi-media');
        media.querySelector('iframe')?.remove();
        media.classList.remove('mi-media--video');
        const image = media.querySelector('img');
        if (image) image.hidden = false;
      });
      active = null;
    }
    function video(detail, id) {
      if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
      const media = detail.querySelector('.mi-media');
      media.querySelector('iframe')?.remove();
      const image = media.querySelector('img');
      if (image) image.hidden = true;
      media.classList.add('mi-media--video');
      const frame = document.createElement('iframe');
      frame.src = `https://www.youtube-nocookie.com/embed/${id}?rel=0&autoplay=0&playsinline=1`;
      frame.title = media.dataset.title;
      frame.allow = 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      media.append(frame);
      detail.querySelectorAll('.mi-switch').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.video === id));
      });
    }
    function show(scroll = false) {
      let hash = location.hash;
      try { hash = decodeURIComponent(hash); } catch { /* Ignore malformed fragments. */ }
      const detail = details.find(item => `#${item.id}` === hash);
      if (detail && active === detail) return;
      stop();
      overview.hidden = models.hidden = Boolean(detail);
      if (detail) {
        active = detail;
        detail.hidden = false;
        const media = detail.querySelector('.mi-media');
        if (media.dataset.video) video(detail, media.dataset.video);
        if (scroll) {
          detail.scrollIntoView({ block: 'start', behavior: 'instant' });
          detail.querySelector('h2').focus({ preventScroll: true });
        }
      } else if (scroll) {
        const target = origin && !origin.hidden ? origin : search;
        target.scrollIntoView({ block: 'center', behavior: 'instant' });
        target.focus({ preventScroll: true });
      }
    }
    function filter() {
      const query = search.value.trim().toLocaleLowerCase();
      let visible = 0;
      cards.forEach(card => {
        card.hidden = Boolean((brand && card.dataset.brand !== brand) || !card.dataset.model.toLocaleLowerCase().includes(query));
        if (!card.hidden) visible++;
      });
      count.textContent = `${visible} ${visible === 1 ? count.dataset.one : count.dataset.many}`;
      root.querySelector('.mi-empty').hidden = visible > 0;
    }
    root.addEventListener('click', event => {
      const card = event.target.closest('.mi-card');
      const back = event.target.closest('.mi-back');
      if ((card || back) && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        event.preventDefault();
        if (card) origin = card;
        history.pushState(null, '', (card || back).getAttribute('href'));
        show(true);
        return;
      }
      const button = event.target.closest('.mi-filters button');
      if (button) {
        brand = button.dataset.brand;
        filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        filter();
      }
      const choice = event.target.closest('.mi-switch');
      if (choice) video(choice.closest('.mi-detail'), choice.dataset.video);
    }, options);
    search.addEventListener('input', filter, options);
    window.addEventListener('hashchange', () => show(true), options);
    window.addEventListener('popstate', () => show(true), options);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) { stop(); controller.abort(); }
    }, options);
    filter();
    show(Boolean(location.hash));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
